import Asddress from "./ContactPageC/address/Address"
import "../pages/ContactPageC/contact.css";
// import "./contact.css";
export default function Contact() {
  return <div className="addresscolor">
   <br></br> 
 
  <br></br>
  <Asddress/>
  <br></br>
  <br></br>
   <br></br>
  <br></br>
  <br></br>
  <br></br>
  <br></br>
   <></>
  </div>
  
  
}
